// https://stackoverflow.com/questions/75938170/how-do-i-run-my-tsup-javascript-bundle-on-browser
export { Tooltip } from './tooltip'
export type { TooltipProps, TooltipPlacementProps } from './tooltip'
